import React from 'react';
import { SearchCheckIcon, ShieldCheckIcon, VoteIcon } from 'lucide-react';
import { Highlight } from './Heading';
import { SectionHeader } from './SectionHeader';
import { Reveal } from './Reveal';
import { CensusSearch } from './CensusSearch';
import { election } from '../data/election';
const steps = [{
  icon: SearchCheckIcon,
  title: 'Consulta',
  text: 'Busca tu empresa en el censo.',
  featured: true
}, {
  icon: ShieldCheckIcon,
  title: 'Verifica',
  text: 'Confirma que está habilitada.',
  featured: false
}, {
  icon: VoteIcon,
  title: 'Vota Lista No. 1',
  text: election.dateLabel + '.',
  featured: false
}];
export function CensusSection() {
  return <section id="censo" className="bg-white py-12 md:py-20" data-id="element-204" data-mp="s1sfizs0g3cp">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-205" data-mp="nz5lqtbs48cv">
        <div className="rounded-[24px] bg-[#EAF1FB] p-4 sm:p-8 md:rounded-[28px] lg:p-10" data-id="element-206" data-mp="11xvj8a2iga1r">
          <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:items-end lg:gap-10" data-id="element-207" data-mp="11vj0huoxhvnn">
            <SectionHeader eyebrow="Elecciones 3 de diciembre" title={<>
                  Consulta el <Highlight tone="accent" data-id="element-209" data-mp="ihs9u0bcddh1">censo electoral</Highlight>
                </>} subtitle="¿Tu empresa está habilitada para votar? Búscala aquí en el censo de la Cámara de Comercio de Cali." data-id="element-208" data-mp="dhmf2b9rzauq" />
            <ol className="grid gap-2 sm:grid-cols-3" data-id="element-210" data-mp="rfax7bcgk3w3">
              {steps.map((s, i) => <Reveal key={s.title} delay={0.1 + i * 0.06} className="h-full" data-id="element-211" data-mp="wg8hpukxxa0r" data-mpi={i}>
                  <li className={`flex h-full items-start gap-3 rounded-xl p-3.5 ${s.featured ? 'bg-primary text-white' : 'bg-white/70 text-primary'}`} data-id="element-212" data-mp="11e0hfartu0fi">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${s.featured ? 'bg-accent-gold text-primary' : 'bg-primary/10'}`} data-id="element-213" data-mp="1b77nkxue5kgn">
                      <s.icon className="h-4 w-4" data-id="element-214" data-mp="3ga0o2fgdvg6u" />
                    </span>
                    <div className="min-w-0" data-id="element-215" data-mp="3c8f8gmcgsnsy">
                      <p className="text-sm font-bold" data-id="element-216" data-mp="3c5ja4wwpfx3z">
                        {i + 1}. {s.title}
                      </p>
                      <p className={`mt-0.5 text-xs leading-snug ${s.featured ? 'text-white/75' : 'text-foreground/65'}`} data-id="element-217" data-mp="3l8keas20fe50">
                        {s.text}
                      </p>
                    </div>
                  </li>
                </Reveal>)}
            </ol>
          </div>

          <Reveal delay={0.1} className="mt-6 sm:mt-8" data-id="element-218" data-mp="cs8tqueryk5h">
            <CensusSearch data-id="element-219" data-mp="crpmc7mr3e5p" />
          </Reveal>
        </div>
      </div>
    </section>;
}